import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _getIteratorMethod from "@babel/runtime-corejs3/core-js/get-iterator-method";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _extends from "@babel/runtime-corejs3/helpers/extends";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { var _context; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import isLeafNode from './isLeafNode';
function normalizeAsArray(input) {
  if (input == null) {
    return [];
  } else if (Array.isArray(input)) {
    return input;
  } else {
    return [input];
  }
}
/** @deprecated 该 API 已经过时，请使用 makeRecursiveMapper */
export default function traverseColumn(fn) {
  return function (_ref) {
    var columns = _ref.columns,
      dataSource = _ref.dataSource;
    return {
      dataSource: dataSource,
      columns: dfs(columns, 0).result
    };
    function dfs(columns, parentStartColIndex) {
      var flatColCount = 0;
      var result = [];
      var _iterator = _createForOfIteratorHelper(columns),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var col = _step.value;
          var startColIndex = parentStartColIndex + flatColCount;
          var unNormalized = void 0;
          if (isLeafNode(col)) {
            unNormalized = fn(col, {
              range: {
                start: startColIndex,
                end: startColIndex + 1
              },
              dataSource: dataSource
            });
            flatColCount += 1;
          } else {
            var dfsResult = dfs(col.children, startColIndex);
            unNormalized = fn(_extends(_extends({}, col), {
              children: dfsResult.result
            }), {
              range: {
                start: startColIndex,
                end: startColIndex + dfsResult.flatColCount
              },
              dataSource: dataSource
            });
            flatColCount += dfsResult.flatColCount;
          }
          result.push.apply(result, _toConsumableArray(normalizeAsArray(unNormalized)));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return {
        result: result,
        flatColCount: flatColCount
      };
    }
  };
}